/** Home e painéis. Listagens com ação por linha, cadastros e edição ficam de fora. */
const HOME_OR_DASHBOARD = new Set(['/', '/portal', '/map']);

export function isLinaDockVisiblePath(pathname) {
  const raw = String(pathname || '/');
  const path = raw.length > 1 && raw.endsWith('/') ? raw.slice(0, -1) : raw;
  return HOME_OR_DASHBOARD.has(path);
}
